import script from "./MapaCoordenadaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MapaCoordenadaModal.vue?vue&type=script&setup=true&lang=js"

import "./MapaCoordenadaModal.vue?vue&type=style&index=0&id=e39d5d40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e39d5d40"]])

export default __exports__